import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import App from './App.vue';
import router from './router';
import store from './store/index';

Vue.config.productionTip = false;

/* eslint-disable */
Object.getByString = function (o, s) {
  s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  s = s.replace(/^\./, '');           // strip a leading dot
  const a = s.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }
  return o;
};

// eslint-disable-next-line func-names
Object.setByString = function (obj, path, value) {
  var i;
  path = path.split('.');
  for (i = 0; i < path.length - 1; i++) {
    obj = obj[path[i]];
  }
  obj[path[i]] = value;
};

Vue.use(Vuetify, {
  theme: {
    primary: '#e75239',
  },
});

Vue.directive('rc-loader', {
  bind(el, binding) {
    el.classList.add('load-wrapper');
    const pendingDiv = document.createElement('div');
    pendingDiv.classList.add('isPending');
    pendingDiv.style['--topOffset'] = `calc(50% + ${el.scrollTop}px)`;
    if (binding.value) {
      pendingDiv.style.setProperty('--topOffset', `calc(50% + ${el.scrollTop}px)`);
      el.classList.add('load-content');
    } else {
      el.classList.remove('load-content');
    }
    el.append(pendingDiv);
  },
  componentUpdated(el, binding) {
    if (binding.value) {
      const pendingDiv = el.getElementsByClassName('isPending');
      pendingDiv[0].style.setProperty('--topOffset', `calc(50% + ${el.scrollTop}px)`);
      el.classList.add('load-content');
    } else {
      el.classList.remove('load-content');
    }
  },
});

Vue.filter('spaceOut', (number) => {
  if (number) {
    const parts = number.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return parts.join(' ');
  }
  if (number === 0) {
    return 0;
  }
  return null;
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
